// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3kf8R","col":"styles_col__2rBXM"};